export enum OwnerUserType {
  Unknown = 0,
  SuperIntendent = 1,
  Owner = 2,
  Delegate = 3
}